import { render, staticRenderFns } from "./QrCodeKyc.vue?vue&type=template&id=327e0300&scoped=true"
import script from "./QrCodeKyc.vue?vue&type=script&lang=js"
export * from "./QrCodeKyc.vue?vue&type=script&lang=js"
import style0 from "./QrCodeKyc.vue?vue&type=style&index=0&id=327e0300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327e0300",
  null
  
)

/* custom blocks */
import block0 from "./QrCodeKyc.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports